'use client'

import React, { FC, useState } from 'react'

import Button from '@/components/common/Button/Button'
import VideoModal from '@/components/common/VideoModal/VideoModal'
import Play from '@/components/svg/Play'

type Props = {
  iconLabel: string
  linkLabel: string
}

const LocalizedVideo: FC<Props> = ({ iconLabel, linkLabel }) => {
  const [videoOpen, setVideoOpen] = useState(false)
  return (
    <>
      <Button
        id={'secondary-play_video-banner'}
        variant="transparent"
        color="green"
        onClick={() => setVideoOpen(true)}
      >
        <Play aria-label={iconLabel} />
        {linkLabel}
      </Button>
      <VideoModal
        open={videoOpen}
        handleClose={() => setVideoOpen(false)}
        videoUrl="../assets/Videos/brick-commercial-full-day"
      />
    </>
  )
}

export default LocalizedVideo
